<template>
  <div class="onepager-container">
    <onepager
        v-for="onepager in onepagers"
        :key="onepager.type"
        :environment="environment"
        :logo="logo"
        :multiRowPath="onepager.multiRowPath"
        :products="onepager.products"
        :tableConfig="onepager.tableConfig"
        :template="getTemplateManager(onepager.template)"
        :type="onepager.type"
    ></onepager>
    <document-container
        v-if="lastPage[appInstance]"
        document-type="onepager" :logo="logo" class="last-page">
      <div
          slot="raw-body"
      >
        <Textblock :data="lastPage[appInstance]"></Textblock>
      </div>
    </document-container>

  </div>
</template>

<script>
import Onepager
  from './Onepager'
import ProductService
  from "../../service/ProductService"
import ConfigService
  from "../../service/ConfigService"
import {
  EventBus,
} from "../../service/EventBus"
import TemplateManager
  from '../../service/TemplateManager'
import TokenService
  from "../../service/TokenService"
import DocumentContainer
  from "../document/DocumentContainer"
import Textblock
  from "../block/BlockText.vue"

export default {
  name: 'onepager-container',

  // vue-head is used to set & update the css
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/${this.environment}/style/onepager.css`,
        },
      ]
    },
  },

  components: {
    Textblock,
    DocumentContainer,
    Onepager,
  },

  data: function () {
    return {
      onepagers: [],
      pageCounter: 0,
      token: null,
      lastPage: {
        QQD3BERE: {
          title: "Wichtiger Hinweis",
          body: [
            "Bei dieser Information handelt es sich um eine Marketingmitteilung. Bei dieser Information und bei Referenzen zu Emittenten, Finanzinstrumenten oder Finanzprodukten handelt es sich nicht um eine Anlagestrategieempfehlung im Sinne des Artikels 3 Absatz 1 Nummer 34 der Verordnung (EU) Nr. 596/2014 oder um eine Anlageempfehlung im Sinne des Artikels 3 Absatz 1 Nummer 35 der Verordnung (EU) Nr. 596/2014 jeweils in Verbindung mit § 85 Absatz 1 WpHG. Als Marketingmitteilung genügt diese Information nicht allen gesetzlichen Anforderungen zur Gewährleistung der Unvoreingenommenheit von Anlageempfehlungen und Anlagestrategieempfehlungen und unterliegt keinem Verbot des Handels vor der Veröffentlichung von Anlageempfehlungen und Anlagestrategieempfehlungen. Diese Information soll Ihnen Gelegenheit geben, sich selbst ein Bild über eine Anlagemöglichkeit zu machen. Es ersetzt jedoch keine rechtliche, steuerliche oder individuelle finanzielle Beratung. Ihre Anlageziele sowie Ihre persönlichen und wirtschaftlichen Verhältnisse wurden ebenfalls nicht berücksichtigt. Wir weisen daher ausdrücklich darauf hin, dass diese Information keine individuelle Anlageberatung darstellt. Eventuell beschriebene Produkte oder Wertpapiere sind möglicherweise nicht in allen Ländern oder nur bestimmten Anlegerkategorien zum Erwerb verfügbar. Diese Information darf nur im Rahmen des anwendbaren Rechts und insbesondere nicht an Staatsangehörige der USA oder dort wohnhafte Personen verteilt werden. Diese Information wurde weder durch eine unabhängige Wirtschaftsprüfungsgesellschaft noch durch andere unabhängige Experten geprüft. Die zukünftige Wertentwicklung eines Investments unterliegt unter Umständen der Besteuerung, die von der persönlichen Situation des Anlegers abhängig ist und sich zukünftig ändern kann. Renditen von Anlagen in Fremdwährung können aufgrund von Währungsschwankungen steigen oder sinken. Mit dem Kauf, dem Halten, dem Umtausch oder dem Verkauf eines Finanzinstruments sowie der Inanspruchnahme oder Kündigung einer Wertpapierdienstleistung können Kosten entstehen, welche sich auf die erwarteten Erträge auswirken. Bei Investmentfonds sollten Sie eine Anlageentscheidung in jedem Fall auf Grundlage der Verkaufsunterlagen (Basisinformationsblatt, Darstellung der früheren Wertentwicklung, Verkaufsprospekt, aktueller Jahresbericht und ggf. Halbjahresbericht) treffen, denen ausführliche Hinweise zu den Chancen und Risiken des jeweiligen Fonds zu entnehmen sind. Eine Anlageentscheidung sollte auf Basis aller Eigenschaften des Fonds getroffen werden und sich nicht nur auf nachhaltigkeitsrelevante Aspekte beziehen. Nachhaltigkeitsbezogene Offenlegungen finden Sie unter www.berenberg.de/esg-investments. Bei Wertpapieren, zu denen ein Wertpapierprospekt vorliegt, sollten Sie Anlageentscheidungen in jedem Fall auf Grundlage des Wertpapierprospekts treffen, dem ausführliche Hinweise zu den Chancen und Risiken dieses Finanzinstruments zu entnehmen sind, im Übrigen wenigstens auf Basis des Produktinformationsblattes. Der Investmentfonds weist aufgrund seiner Zusammensetzung / der von dem Fondsmanagement verwendeten Techniken eine erhöhte Volatilität auf, d.h. die Anteilspreise können auch innerhalb kurzer Zeiträume stärkeren Schwankungen nach unten oder nach oben unterworfen sein. Alle vorgenannten Unterlagen können bei der Joh. Berenberg, Gossler & Co. KG (Berenberg), Überseering 28, 22297 Hamburg, kostenlos angefordert werden. Die Verkaufsunterlagen der Fonds sowie die Produktinformationsblätter zu anderen Wertpapieren stehen über ein Download-Portal unter der Internetadresse productdocumentsuite.berenberg.de zur Verfügung. Die Verkaufsunterlagen der Fonds können ebenso bei der jeweiligen Kapitalverwaltungsgesellschaft angefordert werden. Die jeweils konkreten Adressangaben stellen wir Ihnen auf Nachfrage gerne zur Verfügung. Eine Zusammenfassung Ihrer Anlegerrechte in deutscher Sprache finden Sie auf der Homepage der Kapitalverwaltungsgesellschaft (www.universal-investment.com/de/unternehmen/compliance/anlegerrechte). Zudem weisen wir darauf hin, dass Universal-Investment bei Fonds für die sie als Kapitalverwaltungsgesellschaft Vorkehrungen für den Vertrieb der Fondsanteile in EU-Mitgliedstaaten getroffen hat, beschließen kann, diese gemäß Artikel 93a der Richtlinie 2009/65/EG und Artikel 32a der Richtlinie 2011/61/EU, insbesondere also mit Abgabe eines Pauschalangebots zum Rückkauf oder zur Rücknahme sämtlicher entsprechender Anteile, die von Anlegern in dem entsprechenden Mitgliedstaat gehalten werden, aufzuheben. Bei einem Fondsinvestment werden stets Anteile an einem Investmentfonds erworben, nicht jedoch ein bestimmter Basiswert (z.B. Aktien an einem Unternehmen), der vom jeweiligen Fonds gehalten wird. Die in diesem Dokument enthaltenen Aussagen basieren entweder auf eigenen Quellen des Unternehmens oder auf öffentlich zugänglichen Quellen Dritter und spiegeln den Informationsstand zum Zeitpunkt der Erstellung der unten angegebenen Präsentation wider. Nachträglich eintretende Änderungen können in diesem Dokument nicht berücksichtigt werden. Angaben können sich durch Zeitablauf und/oder infolge gesetzlicher, politischer, wirtschaftlicher oder anderer Änderungen als nicht mehr zutreffend erweisen. Wir übernehmen keine Verpflichtung, auf solche Änderungen hinzuweisen und/oder eine aktualisierte Information zu erstellen. Wichtige Hinweise und Informationen zu Index-, Marktdaten und ESG-Ratings finden Sie unter www.berenberg.de/rechtliche-hinweise/lizenzhinweise/. Wir weisen darauf hin, dass frühere Wertentwicklungen, Simulationen oder Prognosen kein verlässlicher Indikator für die künftige Wertentwicklung sind und dass Depotkosten entstehen können, die die Wertentwicklung mindern. Zur Erklärung verwandter Fachbegriffe steht Ihnen auf www.berenberg.de/glossar ein Online-Glossar zur Verfügung. Das in dieser Unterlage verwendete Bildmaterial dient ausschließlich zu illustrativen Zwecken. Es stellt keinen Bezug zu spezifischen Produkten, Dienstleistungen, Personen oder tatsächlichen Situationen her und ist nicht als Grundlage für Entscheidungen oder Handlungen zu verstehen.",
          ],
        },
      },
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    productIds: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  computed: {
    logo() {
      return ['config', this.environment, 'images', 'logo.png'].join('/')
    },
  },

  methods: {
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
    fetchProducts() {
      const typeMap = {
        BOND: 'onepager_bonds',
        FUND: 'onepager_funds',
        STOCK: 'onepager_stock',
        CUSTOM: 'onepager_custom',
        DERIVATE: 'onepager',
      }

      ProductService.getProductsFromBroker(
          this.environment,
          this.appInstance,
          this.productIds.split('+'),
          this.token,
      ).then(result => {
            result.data.data.map(instrumentType => {
              let sortedResult = this._.sortBy(instrumentType.onepagers, 'type')

              sortedResult.map(productsByType => {
                ConfigService.getDocumentConfig(
                    this.environment,
                    typeMap[instrumentType.type],
                    productsByType.market ? productsByType.market.toLocaleLowerCase() : 'default',
                    productsByType.type ? productsByType.type : 'default',
                ).then(documentConfig => {
                  this.onepagers.push({
                    template: documentConfig.data,
                    products: productsByType.products,
                    tableConfig: productsByType.columns,
                    multiRowPath: productsByType.pathToMultiRowCount,
                  })
                })
              })
            })
          },
      )
    },
  },

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    this.fetchProducts()
  },

  mounted() {
    EventBus.$on('pageCounter', amount => {
      this.pageCounter += amount
    })
  },

  watch: {
    // changes in the url are applied instantaneously
    environment() {
      this.$emit('updateHead')
    },
    productIds() {
      this.onepagers = []
      this.fetchProducts()
    },
    // token() {
    //   this.fetchProducts()
    // }
  },
}
</script>



// WEBPACK FOOTER //
// OnepagerContainer.vue?391348fe